import { SVGProps } from 'react';

const SvgFamily = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M192 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-86.4 144h77.1c-4.3-9.8-6.7-20.6-6.7-32 0-3.9.3-7.8.8-11.5-8.3-2.9-17.2-4.5-26.4-4.5h-44.8c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352h32v-16c0-11.1 1.6-21.9 4.6-32h-63c-9.4 0-16.7-8-15.9-17.3l4.1-49.3C75.1 220.8 89 208 105.6 208zM336 176c0 11.4-2.4 22.2-6.7 32h70.4c7.1 0 13.4 4.7 15.4 11.6L448.4 336H368v16c0 11.2-1.9 22-5.5 32H400v104c0 13.3 10.7 24 24 24s24-10.7 24-24V384h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4h-31.5c-11.8 0-23 3.2-32.6 8.9.2 2.3.3 4.7.3 7.1zM448 64a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm32 112v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 16v-16c0-44.2-35.8-80-80-80s-80 35.8-80 80v16c0 24 13.2 44.9 32.7 55.8-.5 2.7-.7 5.4-.7 8.2v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-2.8-.2-5.5-.7-8.2C322.8 396.9 336 376 336 352z" />
  </svg>
);
export default SvgFamily;
